import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <path
      d="M22.008 0h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-6 8h6V2h-6v6zm-8 6h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2zm-6 8h6v-6h-6v6zm17-8a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m-14-14.982c-.362 0-.725.238-1 .715L.235 8.268c-.55.953-.1 1.732 1 1.732H8.78c1.1 0 1.55-.78 1-1.732L6.008 1.733c-.274-.477-.637-.715-1-.715m0 2.982l2.31 4h-4.62l2.31-4"
      fill="#43C6F4"
      fillRule="evenodd"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconPlatform.jsx